export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12073.730d71a0.jpg";